import React, { useState, useEffect } from "react";
import styled from "styled-components";
import queryString from "query-string";

import { LeadingTitle, FooterSection } from "@components";
import {
  ObligationAPI,
  ShortDescriptionAPI,
  StockListingChronologyAPI,
} from "@api";
import moment from "moment";
import "./CorporateAction.scss";
import { Info } from "@icons";
import { useTranslation } from "react-i18next";

const InvestorContainer = styled.div`
  background-color: #f9f9f9;
  padding-top: 56px;
  overflow: hidden;

  @media screen and (max-width: 767px) {
    padding-top: 0;
  }
`;

const CorporateAction = function () {     
  const {t} = useTranslation();
  const [shortDesc, setShortDesc] = useState(null);
  useEffect(() => {
    const loadData = async () => {
      const { data } = await ShortDescriptionAPI({
        loc: "riwayat_aksi_korporasi",
      });
      setShortDesc(data.data);
    };

    if (!shortDesc) {
      loadData();
    }
  }, [shortDesc]);
  return (
    <InvestorContainer>
      <LeadingTitle
        title={t("riwayat_aksi_korporasi")}
        subtitle={shortDesc !== null ? shortDesc[0].description : ""}
      />
      <Body />
      <FooterSection currentPage={t("riwayat_aksi_korporasi")}/>
    </InvestorContainer>
  );
};

const Body = function () {    
  const {t} = useTranslation();
  const [obligation, setObligation] = useState();
  const [kronologisPencatatanSaham, setKronologisPencatatanSaham] = useState();
  const pillTab = window.location.hash;
  const [activeTabA, setActiveTabA] = useState("");
  const [activeTabB, setActiveTabB] = useState("");

  useEffect(() => {
    const loadObligationSubordinasi = async () => {
      const filter = {
        cat: "ordinasi",
        orderBy: "desc"
      };
      const { data } = await ObligationAPI(queryString.stringify(filter));
      setObligation(data?.data?.result || []);
    };

    const loadKronologisPencatatanSahamData = async () => {
      const { data } = await StockListingChronologyAPI({
        orderBy: "desc",
        limit: "10",
        page: "1",
      });
      setKronologisPencatatanSaham(data.data.result);
    };

    if (!kronologisPencatatanSaham) {
      loadKronologisPencatatanSahamData();
    }

    if (!obligation) {
      loadObligationSubordinasi();
    }

    if (pillTab === "" || pillTab === "#penerbitan-obligasi-subordinasi") {
      setActiveTabA("active");
    } else if (pillTab === "#kronologis-pencatatan-saham") {
      setActiveTabB("active");
    }
  }, [activeTabA, activeTabB, pillTab, obligation, kronologisPencatatanSaham]);

  const isKronologis = pillTab === "#kronologis-pencatatan-saham";
  return (
    <div className="corporate-action-content">
      <ul className="nav nav-underline mb-3" id="pills-tab" role="tablist">
        <li className="nav-item flex-grow-1" role="presentation">
          <button
            className={`nav-link w-100 ${activeTabA ? "active" : ""}`}
            id="pills-obligasi-tab"
            data-bs-toggle="pill"
            data-bs-target="#penerbitan-obligasi-subordinasi"
            type="button"
            role="tab"
            aria-controls="penerbitan-obligasi-subordinasi"
            aria-selected="true"
          >
            {t("penerbitan_obligasi_subordinasi")}
          </button>
        </li>
        <li className="nav-item flex-grow-1" role="presentation">
          <button
            className={`nav-link w-100 ${activeTabB ? "active" : ""}`}
            id="pills-saham-tab"
            data-bs-toggle="pill"
            data-bs-target="#kronologis-pencatatan-saham"
            type="button"
            role="tab"
            aria-controls="kronologis-pencatatan-saham"
            aria-selected="false"
          >
            {t("kronologis_pencatatan_saham")}
          </button>
        </li>
      </ul>
      <div className="tab-content" id="pills-tabContent">
        <div
        className={`tab-pane fade ${!isKronologis && "show active" }`}
          id="penerbitan-obligasi-subordinasi"
          role="tabpanel"
          aria-labelledby="pills-obligasi-tab"
        >
          <div className="text-start">
            {!obligation
              ? ""
              : obligation.map((data, i) => {
                  return (
                    <div className="accordion-box" key={i}>
                      <div className="accordion" id={`Triwulan-${i}`}>
                        <div className="accordion-item">
                          <h2
                            className="accordion-header"
                            id={`panelsStayOpen-headingTriwulan-${i}`}
                          >
                            <button
                              className="accordion-button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#panelsStayOpen-collapseTriwulan-${i}`}
                              aria-expanded="false"
                              aria-controls={`panelsStayOpen-collapseTriwulan-${i}`}
                            >
                              {data.title}
                            </button>
                          </h2>
                          <div
                            id={`panelsStayOpen-collapseTriwulan-${i}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`panelsStayOpen-headingTriwulan-${i}`}
                          >
                            <div className="accordion-body">
                              <div className="card-link">
                                <div className="card-link-item">
                                  <div className="card-link-item-left">
                                    <div className="card-link-item-left-box">
                                      <h5 className="label">
                                        {t("tanggal_efektif_pencatatan_obligasi")}
                                      </h5>
                                      <p className="label-date">
                                        {moment(
                                          data.tanggal_pencatatan_saham,
                                          "DD-MM-YYYY hh:mm:ss"
                                        ).format("DD MMMM YYYY")}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="card-link-item-right">
                                    <div className="card-link-item-right__top">
                                      <h5 className="label">
                                        {t("realisasi_nominal")}
                                      </h5>
                                      <p className="label-date">
                                        {data.realisasi_nominal}
                                      </p>
                                    </div>
                                    <div className="card-link-item-right__bottom">
                                      <div className="card-link-item-right__bottom-left">
                                        <div className="card-link-item-right__bottom-left-box">
                                          <h5 className="label">{t("kupon")}</h5>
                                          <p className="label-date">
                                            {data.kupon}
                                          </p>
                                        </div>
                                        <div className="card-link-item-right__bottom-left-box">
                                          <h5 className="label">
                                            {t("jangka_waktu")}
                                          </h5>
                                          <p className="label-date">
                                            {data.jangka_waktu}
                                          </p>
                                        </div>
                                      </div>
                                      <div className="card-link-item-right__bottom-right">
                                        <div className="card-link-item-right__bottom-right-box-top">
                                          <h5 className="label">
                                            {t("harga_penawaran")}
                                          </h5>
                                          <p className="label-date">
                                            {data.harga_penawaran}
                                          </p>
                                        </div>
                                        <div className="card-link-item-right__bottom-right-box-bottom">
                                          <div className="card-link-item-right__bottom-right-box-bottom__box">
                                            <h5 className="label">
                                              {t("jatuh_tempo")}
                                            </h5>
                                            <p className="label-date">
                                              { data.jatuh_tempo !== null ?
                                              moment(
                                                data.jatuh_tempo,
                                                "DD-MM-YYYY hh:mm:ss"
                                              ).format("DD MMMM YYYY") : "-"}
                                            </p>
                                          </div>
                                          <div className="card-link-item-right__bottom-right-box-bottom__box">
                                            <h5 className="label">
                                              {t("pembayaran_bunga")}
                                            </h5>
                                            <p className="label-date">
                                              {data.pembayaran_bunga}
                                            </p>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="card-link-item bottom-content-reverse">
                                  <div className="card-link-item-left">
                                    <div className="card-link-item-left-box bottom-content">
                                      <h5 className="label">{t("pencatatan")}</h5>
                                      <p className="label-date">
                                        {data.pencatatan}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="card-link-item-right">
                                    <div className="card-link-item-right__top">
                                      <h5 className="label">
                                        {t("peringkat_obligasi")}
                                      </h5>
                                      <p className="label-date">
                                        {data.peringkat_obligasi}
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
          </div>
        </div>
        <div
          className={`tab-pane fade ${isKronologis && "show active" }`}
          id="kronologis-pencatatan-saham"
          role="tabpanel"
          aria-labelledby="pills-saham-tab"
        >
          {!kronologisPencatatanSaham
            ? ""
            : kronologisPencatatanSaham.map((data, i) => {
                return (
                  <div className="accordion-box" key={i}>
                    <div className="accordion" id={`Saham-${i}`}>
                      <div className="accordion-item">
                        <h2
                          className="accordion-header"
                          id={`panelsStayOpen-headingSaham-${i}`}
                        >
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#panelsStayOpen-collapseSaham-${i}`}
                            aria-expanded="false"
                            aria-controls={`panelsStayOpen-collapseSaham-${i}`}
                          >
                            {data.title}
                          </button>
                        </h2>
                        <div
                          id={`panelsStayOpen-collapseSaham-${i}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`panelsStayOpen-headingSaham-${i}`}
                        >
                          <div className="accordion-body">
                            <div className="card-link">
                              <div className="card-link-item-2">
                                <div className="card-link-item-2-left">
                                  <div className="card-link-item-2-left-box">
                                    <h5 className="label">
                                      {t("tanggal_efektif_pencatatan_saham")}
                                    </h5>
                                    <p className="label-date">
                                      {moment(
                                        data.tanggal_efektif,
                                        "DD-MM-YYYY hh:mm:ss"
                                      ).format("DD MMMM YYYY")}
                                    </p>
                                  </div>
                                </div>
                                <div className="card-link-item-2-right">
                                  <div className="card-link-item-2-right__top">
                                    <h5 className="label">
                                      {t("nominal_per_saham_kelas_b")}
                                    </h5>
                                    <p className="label-date">
                                      {data.nominal_saham}
                                    </p>
                                  </div>
                                  <div className="card-link-item-2-right__bottom">
                                    <div className="card-link-item-2-right__bottom-left">
                                      <div className="card-link-item-2-right__bottom-left-box">
                                        <h5 className="label">
                                          {t("harga_penawaran_umum")}
                                        </h5>
                                        <p className="label-date">
                                          {data.harga_penawaran}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="card-link-item-2-right__bottom-right">
                                      <div className="card-link-item-2-right__bottom-right-box-top">
                                        <h5 className="label">
                                          {t("penawaran_umum")}
                                        </h5>
                                        <p className="label-date">
                                          {data.penawaran_umum}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="card-link-item-2 bottom-content-reverse">
                                <div className="card-link-item-2-left">
                                  <div className="card-link-item-2-left-box bottom-content">
                                    <h5 className="label">
                                      {t("nama_bursa_tempat_saham_dicatatkan")}
                                    </h5>
                                    <p className="label-date">
                                      {data.nama_bursa}
                                    </p>
                                  </div>
                                </div>
                                <div className="card-link-item-2-right">
                                  <div className="card-link-item-2-right__top">
                                    <h5 className="label">
                                      {t("hasil_penawaran_umum")}
                                    </h5>
                                    <p className="label-date">
                                      {data.hasil_penawaran}
                                    </p>
                                  </div>
                                  <div className="info-section">
                                    <label className="info-label">
                                      *{t("sebelum_dikurangi_biaya_emisi")}{" "}
                                      <Info />
                                    </label>
                                    <div className="info-label-box">
                                      {t("tooltip_riwayat_aksi_korporasi")}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
        </div>
      </div>
    </div>
  );
};

export default CorporateAction;
